module.exports = __webpack_public_path__ + "static/media/type-alert.9646b221.svg";